import { Component } from "@angular/core";

@Component({
    selector: "app-parent-self-sampling-instruction",
    templateUrl: "./parent-self-sampling-instruction.component.html",
    styleUrls: ["./parent-self-sampling-instruction.component.scss"],
    standalone: false
})
export class ParentSelfSamplingInstructionComponent {}
